// How long a green confirmation toast stays up (client, 30/09/2026: 2–3 s went
// by before it could be read).
export const CONFIRMATION_TOAST_MS = 5000;
